import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { useAccessToken } from '#/shared/hooks/useAccessToken';
import { useAxiosConfig } from '#/shared/hooks/useAxiosConfig';
import { getFetchTimesheetQueryKey } from '#/shared/hooks/useTimesheetQuery';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

// TODO: PPL-2240-verify-timesheet-action cleanup - Remove this default url as API will return the correct url
const DEFAULT_RESET_VERIFICATION_URL = '/timesheet-online-approval/reset-verification';

const resetVerificationRequest = async ({ api, url }: { api: AxiosInstance; url: string }) => {
  return api.patch(url);
};

export const useResetVerificationTimesheetMutation = () => {
  const api = useAxiosConfig();
  const queryClient = useQueryClient();
  const jwtToken = useAccessToken();
  const url = useTimesheetStore(state => state.links?.resetVerification?.href ?? DEFAULT_RESET_VERIFICATION_URL);
  const { setPageState } = usePageStateStore();

  return useMutation<AxiosResponse, AxiosError>({
    mutationFn: () => resetVerificationRequest({ api, url }),
    onSuccess: () => {
      if (jwtToken) {
        queryClient.invalidateQueries({ queryKey: getFetchTimesheetQueryKey({ jwtToken }) });
        return;
      }

      setPageState('invalid-token', 401);
    },
  });
};
